import { FieldErrors, FieldValues, UseFormReturn } from "react-hook-form";

export function hasError<T extends FieldValues>(form: UseFormReturn<T, object>): boolean {
  return Object.keys(form.formState.errors).length !== 0;
}

export function hasErrorDescriptive<T extends FieldValues>(form: UseFormReturn<T, object>): false | FieldErrors<T> {
  return Object.keys(form.formState.errors).length === 0 ? false : form.formState.errors;
}
